/**
 * BudgetCategoryService
 * Budget sections ("Sound", "Catering", …) of a budget (nested route).
 * Feeds the bottom-up estimated total: Σ effective section totals + Σ uncategorized items.
 * Route: api/budgets/{budgetId}/categories
 */
export class BudgetCategoryService {
    constructor(http, config) {
        this.http = http;
        this.servicePath = config?.servicePath ?? BudgetCategoryService.DEFAULT_SERVICE_PATH;
    }
    buildUrl(budgetId, path) {
        const base = `${this.servicePath}/api/budgets/${budgetId}/categories`;
        const url = path ? `${base}/${path}` : base;
        return url.startsWith('/') ? url : '/' + url;
    }
    /** All sections of a budget with computed figures (itemCount / itemsTotal / effectiveTotal). */
    async getByBudget(budgetId) {
        const response = await this.getByBudgetRaw(budgetId);
        return response.data ?? [];
    }
    getByBudgetRaw(budgetId) {
        return this.http.get(this.buildUrl(budgetId));
    }
    /** Add a section (one name per budget, case-insensitive). */
    async create(budgetId, body) {
        const response = await this.createRaw(budgetId, body);
        if (!response.data)
            throw new Error(`Failed to create section for budget ${budgetId}`);
        return response.data;
    }
    createRaw(budgetId, body) {
        return this.http.post(this.buildUrl(budgetId), body);
    }
    /** Update a section (partial; clearPlannedAmount nulls the lump amount). */
    async update(budgetId, categoryId, body) {
        const response = await this.updateRaw(budgetId, categoryId, body);
        if (!response.data)
            throw new Error(`Failed to update budget section ${categoryId}`);
        return response.data;
    }
    updateRaw(budgetId, categoryId, body) {
        return this.http.put(this.buildUrl(budgetId, String(categoryId)), body);
    }
    /** NULL-OUT delete — returns how many items were uncategorized. */
    async delete(budgetId, categoryId) {
        const response = await this.deleteRaw(budgetId, categoryId);
        if (!response.success)
            throw new Error(`Failed to delete budget section ${categoryId}`);
        return response.data ?? 0;
    }
    deleteRaw(budgetId, categoryId) {
        return this.http.delete(this.buildUrl(budgetId, String(categoryId)));
    }
}
BudgetCategoryService.DEFAULT_SERVICE_PATH = 'budgets';
//# sourceMappingURL=BudgetCategoryService.js.map